import { apiWrapper } from 'ccs-ui-components';
import { IRecordModel } from '../../../models';

/**
 * Custom hook to call exportServiceConfiguration api
 * @returns promise
 */

const useExportServiceConfiguration = () => {
  async function callExportServiceConfiguration(serviceList: IRecordModel[]) {
    const { responseBody, request, isError, error } = await apiWrapper.post<ArrayBuffer>(
      `${process.env.REACT_APP_API_BASE_URL}/exim/export`,
      {
        recordType: 'service',
        records: serviceList,
      },
      undefined,
      undefined,
      'arraybuffer',
    );

    if (isError) {
      throw error;
    }

    return {
      data: responseBody,
      request
    };
  }

  const exportServiceConfiguration = (serviceList: IRecordModel[]) => callExportServiceConfiguration(serviceList);

  return { exportServiceConfiguration };
};

export default useExportServiceConfiguration;
